import BaseLayerDrawer from '../../../utils/map/BaseLayerDrawer.js'

class ObjectsLayerDrawer extends BaseLayerDrawer {

}

export default ObjectsLayerDrawer
